<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <login-card style="margin-left:200px;" header-color="primary">
        <h3 slot="title" class="title"><br />Reset Password</h3>

        <p slot="subheader" class="subheader">Please reset your password</p>

        <!-- <md-field slot="inputs" class="md-form-group">
          <md-icon>mail_outline</md-icon>
          <label>Email...</label>
          <md-input v-model="username" type="email" />
        </md-field> -->

        <md-field slot="inputs" :class="[
            { 'md-valid': !errors.has('psw1') && touched.psw1 },
            { 'md-form-group': true },
            { 'md-error': errors.has('psw1') && touched.psw1 }
          ]">
          <md-icon>lock_outline</md-icon>
          <label>New Password</label>
          <md-input v-model="psw1" name="password" type="password" v-validate="psw1Validation" ref="password" data-vv-name="psw1" />
        </md-field>

        <md-field slot="inputs" :class="[
            { 'md-valid': !errors.has('psw2') && touched.psw2 },
            { 'md-form-group': true },
            { 'md-error': errors.has('psw2') && touched.psw2 }
          ]">
          <md-icon>lock_outline</md-icon>
          <label>Re-enter Password</label>
          <md-input v-model="psw2" name="password_confirmation" type="password" v-validate="'required|confirmed:password'" data-vv-as="password" data-vv-name="psw2" />
        </md-field>

        <span slot="footer" align="Right" style="margin-right: 25px;">
          <a>&nbsp;</a>
        </span>

        <md-button style="width: 130px;" slot="footer" class="md-primary" @click="resetPsw"> Reset </md-button>

        <span slot="footer" align="Center" style="margin-left: 5px;width: 130px;">
          <a href="#" style="font-size: .85rem; color: #000000de;" @click="goHome">Cancel</a>
        </span>
      </login-card>
    </div>
    <loader :is-visible="isLoading" />
  </div>
</template>

<script>
import Swal from "sweetalert2"
import { LoginCard } from "@/components"
import loader from "@/components/GlobeChek/loader.vue"
import { SlideYDownTransition } from "vue2-transitions"

export default {
  components: {
    LoginCard,
    loader,
    SlideYDownTransition
  },
  data() {
    return {
      isLoading: false,
      psw: null,
      psw1: null,
      psw2: null,
      status: null,
      touched: {
        psw1: false,
        psw2: false,
      },
      psw1Validation: {
        required: true,
        min: 5
      }
    }
  },
  mounted() {},
  methods: {
    goHome() {
      this.$router.push("/")
    },
    resetPsw() {
      this.touched.psw1 = true;
      this.touched.psw2 = true;
      return this.$validator.validateAll().then(valid => {
        if (!valid) {
          return;
        }
        this.psw = null
        if (this.psw1 && this.psw2 && this.psw1.trim() != this.psw2.trim()) {
          return;
        } else {
          this.psw = this.psw1
        }
        this.isLoading = true;
        const urlParams = new URLSearchParams(window.location.search);
        const resetPasswordCode = urlParams.get('gctoken');

        const url = process.env.VUE_APP_URL + "/change-password/" + resetPasswordCode
        const data = {
          password: this.psw
        }
        const config = { headers: { "Content-Type": "application/json" } }

        var vm = this
        window.axios.post(url, data, config).then(response => {
          //POST MESSAGE to Member:
          const config_C = { headers: { "Content-Type": "application/json" } }
          const url_C = process.env.VUE_APP_URL + "/msg/newmessage"
          const data_C = {
            senderID: "Admin@GlobeChek.com",
            senderName: "GlobeChek Admin",
            recipientID: response.data.userId,
            recipientName: response.data.userName,
            msg_subject: "PASSWORD RESET",
            msg_body: "Your GlobeChek password has successfully been reset. -  Thank You!",
            msg_level: "normal"
          }
          window.axios.post(url_C, data_C, config_C)
        })
        .then(() => {
          vm.$router.push("/")
        })
        .catch(errors => {
          console.log(errors);
          Swal.fire({
            title: "Error",
            text: "Invalid code. Please start the proccess again to receive a new email",
            type: "error",
            confirmButtonClass: "md-button md-info",
            buttonsStyling: false,
            timer: 3000
          })
          vm.$router.push("/reset-psw")
        }).finally(()=>{
          this.isLoading = false;
        })
      });
    }
  }
}
</script>

<style></style>
